import React, { useCallback } from 'react';

import { BodyComponent } from 'features/menu/components/product-detail/product-detail-flow/dialogs/body-component';
import { logConfirmationDialogCta } from 'features/menu/components/product-detail/product-detail-flow/dialogs/utils';
import { useProductWizardContext } from 'features/menu/components/product-wizard';
import { ProductWizardStep } from 'features/menu/components/product-wizard/types';
import { useProductWizardFlow } from 'features/menu/components/product-wizard/use-product-wizard-flow';

import ConfirmDialog from 'components/confirm-dialog';
import { t } from 'state/intl/translations';

export const UnsavedChangesDialog = () => {
  const { goToPreviousStep, currentFlowStep } = useProductWizardFlow();

  const {
    showCloseDialog,
    setShowCloseDialog,
    restoreSlotsSelectionSnapshot,
    clearSlotsSelectionSnapshot,
  } = useProductWizardContext();

  const shouldShowDialog =
    showCloseDialog && currentFlowStep.step === ProductWizardStep.ProductCustomization;

  const heading = t('unsavedChangesModalHeader');
  const content = t('unsavedChangesModalDescription');

  const saveLabel = t('saveChanges');
  const discardLabel = t('leaveWithoutSaving');

  const onConfirm = useCallback(() => {
    logConfirmationDialogCta(saveLabel);
    setShowCloseDialog(false);
    clearSlotsSelectionSnapshot();
    goToPreviousStep();
  }, [saveLabel, setShowCloseDialog, clearSlotsSelectionSnapshot, goToPreviousStep]);

  const onCancel = useCallback(() => {
    restoreSlotsSelectionSnapshot();
    logConfirmationDialogCta(discardLabel);
    setShowCloseDialog(false);
    goToPreviousStep();
  }, [restoreSlotsSelectionSnapshot, discardLabel, setShowCloseDialog, goToPreviousStep]);

  return (
    <ConfirmDialog
      showDialog={shouldShowDialog}
      modalAppearanceEventMessage="Confirmation: Product Wizard - Discard Unsaved Changes"
      bodyComponent={<BodyComponent heading={heading} content={content} />}
      confirmLabel={saveLabel}
      cancelLabel={discardLabel}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
